import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Imports => Constants
import {SIZES, THEMES} from '@asdf-constants';

// Imports => Utilities
import {AcGenerateThemeClassNames} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-badge',
  SIZE: {
    DEFAULT: 'ac-badge--size-default',
    SMALL: 'ac-badge--size-small',
    MEDIUM: 'ac-badge--size-medium',
    LARGE: 'ac-badge--size-large',
  },
  THEME: AcGenerateThemeClassNames('ac-badge'),
};

const AcBadge = ({children, theme = 'default', size, className, textClassName, ...rest}) => {
  const getMainClassNames = useMemo(() => {
    return clsx(
      _CLASSES.MAIN,
      theme && _CLASSES.THEME[theme.toUpperCase()],
      size && _CLASSES.SIZE[size.toUpperCase()],
      className
    );
  }, [theme, size, className]);

  return (
    <div className={getMainClassNames} {...rest}>
      <span className={textClassName}>{children}</span>
    </div>
  );
};

AcBadge.displayName = 'AcBadge';
AcBadge.propTypes = {
  /**
   * The theme of the tag
   */
  theme: PropTypes.oneOf(Object.values(THEMES)),
  /**
   * The size of the tag
   */
  size: PropTypes.oneOf(Object.values(SIZES)),
  /**
   * HTML element or Component to render as the badge content.
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  /**
   * For CSS customization
   */
  className: PropTypes.string,
  textClassName: PropTypes.string,
};

export {AcBadge};
export default AcBadge;
